import { PickOrderRequest } from "~/types/api";

import { customClientBApi } from "./customClientBApi";

export const pickOrderApi = customClientBApi.injectEndpoints({
  endpoints: (builder) => ({
    createCustomClientBOrder: builder.mutation<
      void,
      { clientId: Guid; fulfillmentCenterId: Guid } & PickOrderRequest
    >({
      query: ({ clientId, fulfillmentCenterId, ...order }) => ({
        url: `/v1/pickorder`,
        method: "POST",
        params: {
          clientId,
          fulfillmentCenterId
        },
        body: order
      })
    })
  }),
  overrideExisting: false
});
